<template>
  <section class="w-full">
    <div v-if="loading" class="rounded-md icono-carga flex justify-center items-center">
      <LoadingIcon icon="puff" color="rgba(0,0,0,0.4)"/>
    </div>
    <div class="accordion-item" v-else>
      <div id="faq-accordion-content-1" class="accordion-header flex justify-between">
        <button
          class="accordion-button text-base font-medium focus:outline-none dark:text-white"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#faq-accordion-collapse-1"
          aria-expanded="true"
          aria-controls="faq-accordion-collapse-1"
        >
          Filtros de busqueda
        </button>
        <div class="flex justify-end">
          <Button icon="pi pi-search" @click="updateFilter()" class="p-button-sm p-button-info mr-2" v-tooltip.top="'Buscar'"/>
          <Button icon="pi pi-times" class="p-button-sm p-button-danger" @click="resetClear()" v-tooltip.top="'Limpiar'"/>
        </div>
      </div>
      <div
        id="faq-accordion-collapse-1"
        class="accordion-collapse collapse show mt-2"
        aria-labelledby="faq-accordion-content-1"
        data-bs-parent="#faq-accordion-1"
      >
        <div class="accordion-body text-gray-700 dark:text-gray-600 leading-relaxed">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-4">
              <label for="banks">Bancos:</label>
              <Dropdown
                id="banks"
                :options="banks"
                v-model="filters.bankId.value"
                @change="fetchObligationNumbers"
                class="p-inputtext-sm"
                optionLabel="name"
                optionValue="id"
                placeholder="Seleccione una opción"
                :filter="true"
                scrollHeight="auto"
                filterPlaceholder="Buscar por nombre"
              />
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="obligationNumber">Número Obligación:</label>
              <Dropdown
                id="obligationNumber"
                :options="obligations"
                v-model="filters.obligationNumber.value"
                class="p-inputtext-sm"
                optionLabel="obligationNumber"
                optionValue="obligationNumber"
                placeholder="Seleccione una opción"
                :filter="true"
                scrollHeight="auto"
                filterPlaceholder="Buscar por nombre"
              />
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="obligationNumber">Línea de Crédito:</label>
              <Dropdown
                id="obligationNumber"
                :options="creditLines"
                v-model="filters.obligationId.value"
                class="p-inputtext-sm"
                optionLabel="name"
                optionValue="id"
                placeholder="Seleccione una opción"
                :filter="true"
                scrollHeight="auto"
                filterPlaceholder="Buscar por nombre"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="flex flex-col sm:flex-row justify-between items-center border-t border-gray-300 dark:border-dark-5" ></div>
</template>

<script>

import { onMounted, ref } from 'vue'
import listBanks from '../../../services/listBanks'
import listOptionFinancialProducts from '../../../services/listOptionFinancialProducts'
import listCreditLines from '../../../services/listCreditLines'

export default {
  name: 'filtersFinancialProducts',
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup (props, context) {
    const loading = ref()
    const banks = ref()
    const obligations = ref()
    const creditLines = ref()
    const filters = ref(props.modelValue)

    /* Obtener el listado de bancos */
    const fetchBanks = () => {
      return listBanks({ options: true }).then(({ status, data }) => {
        banks.value = data.result
        banks.value.unshift({ id: '', name: 'Todos' })
      }).catch(err => {
        console.error(err.message)
      })
    }

    /* Obtener el listado de las obligaciones asociadas al banco */
    const fetchObligationNumbers = () => {
      const bankId = props.modelValue.bankId.value
      if (bankId) {
        return listOptionFinancialProducts({ bankId }).then(({ status, data }) => {
          obligations.value = data.result
          obligations.value.unshift({ id: '', name: '', obligationNumber: 'Todos' })
          console.log({ obligations })
        }).catch(err => {
          console.error(err.message)
        })
      }

      obligations.value = null
    }

    /* Obtener el listado de las lineas de credito */
    const fetchCreditLines = () => {
      return listCreditLines({ options: true }).then(({ status, data }) => {
        creditLines.value = data.result
        creditLines.value.unshift({ id: '', name: 'Todos' })
      }).catch(err => {
        console.error(err.message)
      })
    }

    const updateFilter = () => {
      filters.value.obligationNumber.value = filters.value.obligationNumber.value === 'Todos' ? '' : filters.value.obligationNumber.value
      filters.value.obligationId.value = filters.value.obligationId.value === 'Todos' ? '' : filters.value.obligationId.value
      context.emit('update:modelValue', filters.value)
      context.emit('search', { filters: filters.value })
    }

    const resetClear = () => {
      filters.value.bankId.value = ''
      filters.value.obligationId.value = ''
      filters.value.obligationNumber.value = ''
      context.emit('update:modelValue', filters.value)
      context.emit('search', { filters: filters.value })
    }

    onMounted(() => {
      fetchBanks()
      fetchCreditLines()
    })

    return {
      updateFilter,
      resetClear,
      fetchObligationNumbers,
      fetchCreditLines,
      filters,
      creditLines,
      obligations,
      status,
      loading,
      banks
    }
  }
}
</script>

<style scoped>

</style>
